import React from 'react';
import { Popover } from 'antd-v5';
import { ExclamationCircleOutlined } from '@ant-design/icons';

const EmojiWarning = () => {
  return (
    <div
      className="fs-12"
      style={{
        color: '#FF4D4F',
        display: 'flex',
        alignItems: 'center',
        marginLeft: '17px',
        marginTop: '5px',
        gap: '5px',
      }}
    >
      <ExclamationCircleOutlined />
      <p style={{ margin: 0, display: 'flex', alignItems: 'center', width: '100%', gap: '4px' }}>
        This message may not be{' '}
        <Popover
          content="If you include emojis, some carriers will not deliver messages over 670 characters."
          title="Emoji Warning"
        >
          <div
            style={{
              textDecoration: 'underline',
            }}
          >
            delivered
          </div>
        </Popover>{' '}
        to some carriers
      </p>
    </div>
  );
};

export default EmojiWarning;
